import styled, { css } from 'styled-components';

export const ScrollContainer = styled.div<{ $scrollAuto: boolean }>`
  padding-bottom: ${({ theme }) => theme.spacing(6)};
  ${({ $scrollAuto }) =>
    $scrollAuto &&
    css`
      height: 100%;
      overflow: auto;
    `};
`;

export const InteractionsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
`;
